import { Chip, ChipOwnProps, Tooltip } from "@mui/material";
import { SkuQualification } from "services/KnowfullyAdminClient";
import { VerificationStatusIds } from "types/common-types";

// Only the verification fields are read, so every row shape (plain, grouped, pre-grouped)
// satisfies this without a union to keep in sync.
export default function SkuQualificationStatusChip({
  value,
}: {
  value: Pick<SkuQualification, "verificationStatus" | "verificationMessage">;
}) {
  const chipProps: ChipOwnProps & { title?: string } =
    value.verificationStatus?.id === VerificationStatusIds.Success
      ? {
          label: value.verificationStatus.name,
          variant: "outlined",
          color: "success",
          title: value.verificationMessage,
        }
      : value.verificationStatus?.id === VerificationStatusIds.Failure
      ? {
          label: value.verificationStatus.name,
          variant: "outlined",
          color: "error",
          title: value.verificationMessage,
        }
      : value.verificationStatus?.id === VerificationStatusIds.Pending
      ? {
          label: value.verificationStatus.name,
          variant: "outlined",
          color: "warning",
          title: value.verificationMessage,
        }
      : {
          label: "",
          variant: "filled",
          color: "default",
          title: value.verificationStatus!.name,
          sx: { width: "60px" },
        };

  const { title, ...rest } = chipProps;

  return (
    <Tooltip title={title}>
      <Chip size="small" {...rest} />
    </Tooltip>
  );
}
